module.exports = __webpack_public_path__ + "img/textalign-justifyleft.66e31bdb.svg";